import { Flex, Skeleton } from 'antd';

import './index.css';

export const SectionGroupButtonsSkeleton = () =>  (
    <Flex justify='center' className='section-group-buttons-skeleton-container' gap="large" wrap='wrap'>
        <Skeleton.Button active className='section-group-buttons-skeleton-button' />

        <Skeleton.Button active className='section-group-buttons-skeleton-button' />
        
        <Skeleton.Button active className='section-group-buttons-skeleton-button' />

        <Skeleton.Button active className='section-group-buttons-skeleton-button' />
    </Flex>
)

